
























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {DistrictStore} from "../../store";
import {District} from "@/interfaces/entity";
import {CommonStatus} from "@/enums/status";
import {RoleDeclare} from "@/enums/roledeclare";

@Component({
    name: "DistrictAction"
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true }) id!: number;
    CommonStatus = CommonStatus;

    get record() {
        return DistrictStore.data[this.id];
    }

    async save(id: number) {
        const district: District = DistrictStore.data[id];
        if (!district) return;
        try {
            DistrictStore.updateDataDistrictV21({ key: id, value: { ...district, isSaving: true } });
            await DistrictStore.editDistrictV21(district);
            DistrictStore.updateCachedDataDistrictV21({ key: id, value: district })
            this.$message.success("Sửa phường/xã thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Sửa phường/xã thất bại");
        } finally {
            DistrictStore.updateDataDistrictV21({ key: id, value: { ...district, isSaving: false } });
            DistrictStore.updateDataDistrictV21({ key: id, value: { ...district, editable: false } });
        }
    }

    edit(id: number) {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_EDIT_REGION)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        const district: any = { ...DistrictStore.data[id] };
        if (!district) return;
        DistrictStore.updateDataDistrictV21({ key: id, value: { ...district, isSaving: false } });
        DistrictStore.updateDataDistrictV21({ key: id, value: { ...district, editable: true } });
    }

    async deleteDistrict(id: number) {
        try {
            DistrictStore.updateDataDistrictV21({ key: id, value: { ...DistrictStore.data[id], isDeleting: true } });
            await DistrictStore.deleteDistrictV21(id);
            this.$message.success("Xóa phường/xã thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa phường/xã thất bại");
        } finally {
            DistrictStore.updateDataDistrictV21({ key: id, value: { ...DistrictStore.data[id], isDeleting: false } });
        }
    }

    close(id: number) {
        let district = { ...DistrictStore.data[id] };
        if (!district) return;
        district = { ...district, ...DistrictStore.cachedData[id], ['editable']: false } as any;
        DistrictStore.updateDataDistrictV21({ key: id, value: district })
    }
}
